/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwImportDtoError } from './PtwImportDtoError';
import {
    PtwImportDtoErrorFromJSON,
    PtwImportDtoErrorFromJSONTyped,
    PtwImportDtoErrorToJSON,
} from './PtwImportDtoError';

/**
 * 
 * @export
 * @interface PtwImportDto
 */
export interface PtwImportDto {
    /**
     * 
     * @type {number}
     * @memberof PtwImportDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PtwImportDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof PtwImportDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwImportDto
     */
    ipAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwImportDto
     */
    hostName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwImportDto
     */
    exportClient?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwImportDto
     */
    measurementsCreated?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwImportDto
     */
    measurementsSkipped?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwImportDto
     */
    databaseChanges?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwImportDto
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {PtwImportDtoError}
     * @memberof PtwImportDto
     */
    error?: PtwImportDtoError | null;
    /**
     * 
     * @type {number}
     * @memberof PtwImportDto
     */
    protocolsSkipped?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwImportDto
     */
    protocolsCreated?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwImportDto
     */
    $type?: PtwImportDtoTypeEnum;
}


/**
 * @export
 */
export const PtwImportDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoPtwImportDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.PtwImportDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwImportDtoTypeEnum = typeof PtwImportDtoTypeEnum[keyof typeof PtwImportDtoTypeEnum];



/**
 * Check if a given object implements the PtwImportDto interface.
 */
export function instanceOfPtwImportDto(value?: unknown): value is PtwImportDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwImportDtoTypeEnum)[0];
}

export function PtwImportDtoFromJSON(json: any): PtwImportDto {
    return PtwImportDtoFromJSONTyped(json, false);
}

export function PtwImportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwImportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': json['date'] == null ? undefined : json['date'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'ipAddress': json['ipAddress'] == null ? undefined : json['ipAddress'],
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'exportClient': json['exportClient'] == null ? undefined : json['exportClient'],
        'measurementsCreated': json['measurementsCreated'] == null ? undefined : json['measurementsCreated'],
        'measurementsSkipped': json['measurementsSkipped'] == null ? undefined : json['measurementsSkipped'],
        'databaseChanges': json['databaseChanges'] == null ? undefined : json['databaseChanges'],
        'isCompleted': json['isCompleted'] == null ? undefined : json['isCompleted'],
        'error': json['error'] == null ? undefined : PtwImportDtoErrorFromJSON(json['error']),
        'protocolsSkipped': json['protocolsSkipped'] == null ? undefined : json['protocolsSkipped'],
        'protocolsCreated': json['protocolsCreated'] == null ? undefined : json['protocolsCreated'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwImportDtoToJSON(value?: PtwImportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'date': value['date'],
        'userName': value['userName'],
        'ipAddress': value['ipAddress'],
        'hostName': value['hostName'],
        'exportClient': value['exportClient'],
        'measurementsCreated': value['measurementsCreated'],
        'measurementsSkipped': value['measurementsSkipped'],
        'databaseChanges': value['databaseChanges'],
        'isCompleted': value['isCompleted'],
        'error': PtwImportDtoErrorToJSON(value['error']),
        'protocolsSkipped': value['protocolsSkipped'],
        'protocolsCreated': value['protocolsCreated'],
        '$type': value['$type'],
    });
}

